import React from 'react'

import { css } from 'design'
import { cn } from 'util/cn'

export type PresenceProps = {
  variant: 'online' | 'offline' | 'away'
  size?: 'small' | 'medium' | 'large'
  outline?: boolean
} & React.HTMLAttributes<HTMLDivElement>

export const Presence = ({
  variant = 'offline',
  size = 'medium',
  outline = false,
  className,
  ...props
}: PresenceProps) => (
  <div
    className={cn(
      presenceStyles({ variant, size, outline }),
      `topic__presence topic__presence--${variant}`,
      `topic__presence--${size}`,
      className,
    )}
    title={variant}
    {...props}
  />
)

const presenceStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '$full',

  $$size: '$space$3',
  $$color: '$colors$grey400',
  $$backgroundColor: 'transparent',

  '&::after': {
    content: '""',
    display: 'block',
    width: '$$size',
    height: '$$size',
    borderRadius: '$full',
    border: '2px solid $$color',
    backgroundColor: '$$backgroundColor',
  },

  variants: {
    variant: {
      online: {
        $$color: 'transparent',
        $$backgroundColor: '$colors$green500',
      },
      away: {
        $$color: '$colors$green500',
        $$backgroundColor: 'transparent',
      },
      offline: {
        $$color: '$colors$grey400',
        $$backgroundColor: 'transparent',
      },
    },
    size: {
      small: {
        $$size: '$space$2',
      },
      medium: {
        $$size: '$space$3',
      },
      large: {
        $$size: '$space$4',
      },
    },
    outline: {
      true: {
        '&::after': {
          boxShadow: '0px 0px 0px 2px $colors$backgroundSecondary',
        },
      },
      false: {},
    },
  },
  defaultVariants: {
    variant: 'offline',
    size: 'small',
  },
})
